const ITEMS = [
  "Boom Barriers",
  "Speed Breakers",
  "Retro-Reflective Sign Boards",
  "Delineators",
  "Traffic Cones",
  "Reflective Studs",
  "MIRC Compliant",
  "Bulk Dispatch Pan-India",
];

export const Marquee = () => (
  <div
    className="relative border-y border-amber-500/20 bg-[#0B0F17] py-5 overflow-hidden"
    data-testid="editorial-marquee"
  >
    <div className="animate-marquee flex w-max items-center gap-10 whitespace-nowrap">
      {[...ITEMS, ...ITEMS].map((item, i) => (
        <span key={i} className="flex items-center gap-10">
          <span className="font-display text-xl sm:text-2xl font-semibold uppercase tracking-[0.15em] text-zinc-500">
            {item}
          </span>
          <span className="w-2 h-2 bg-amber-500 rotate-45 shrink-0" />
        </span>
      ))}
    </div>
  </div>
);
